import { BrokersMembersTable } from './BrokersMembersTable'

export function BrokersMembersListView () {
  return (
    <div className='sm:flex-auto px-3 sm:px-0 mb-3 sm:mb-0 sm:text-left'>
      <div className='px-4 sm:px-0'>
        <div className='sm:flex sm:items-center'>
          <div className='sm:flex-auto'>
            <h1 className='h1 mb-8'>
              Members
            </h1>
          </div>
        </div>
        <div className='flow-root'>
          <BrokersMembersTable />
        </div>
      </div>
    </div>
  )
}
